// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14Amm","footer":"styles_footer__2kAsW","passCodeTooltip":"styles_passCodeTooltip__3sdmP"};